import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Button, MenuItem, Select, Typography } from "@mui/material";
import { useState } from "react";
import { FormData } from "./FormData";

const createIcPatronChat = (data: FormData) => {
  const elem = document.getElementById("embeddedChatTarget");

  elem?.childNodes.forEach((v) => v.remove());

  const newScript = document.createElement("script");

  newScript.type = "text/javascript";
  // Name (First|Last)
  // Email
  // Phone
  // Not Used
  // Campaign Id
  // Not Used
  // Not Used
  // Zip
  // Type (WaitForInput or Agent)
  newScript.innerHTML = `icPatronChat.init({serverHost:'${
    process.env.REACT_APP_INCONTACT_SERVERNAME
  }',bus_no:${process.env.REACT_APP_INCONTACT_BUSINESS_NUMBER},poc:'${
    process.env.REACT_APP_INCONTACT_POINT_OF_CONTACT
  }',params:['${data?.firstName + "|" + data?.lastName}', '${data?.email}', '${
    data?.phone
  }', 'TheChatSource', '${
    process.env.REACT_APP_MARKETING_CAMPAIGN_CODE
  }', '', '', '${data?.zip}', '${data.type}']});`;

  elem?.appendChild(newScript);
};

const App: React.FC = () => {
  const [data, setData] = useState<FormData>({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    zip: "",
    type: "WaitForInput",
  });

  const [chatCreated, setChatCreated] = useState(false);

  const onClickChat = () => {
    createIcPatronChat(data);

    setChatCreated(true);
  };

  return (
    <>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Typography>
            Input values to be passed to the InContact embedded Chat client as
            parameters.
          </Typography>
          <Typography>
            Field values are not validated before being sent to the server,
            please be careful of your inputs.
          </Typography>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={1}>
            <Typography align="right">First Name:</Typography>
          </Grid>
          <Grid item xs={2}>
            <TextField
              id="first-name"
              label="First Name"
              variant="outlined"
              value={data?.firstName}
              disabled={chatCreated}
              onChange={(e) => {
                setData((d) => ({
                  ...d,
                  firstName: e.target.value || "",
                }));
              }}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={1}>
            <Typography align="right">Last Name:</Typography>
          </Grid>
          <Grid item xs={2}>
            <TextField
              id="last-name"
              label="Last Name"
              variant="outlined"
              value={data?.lastName}
              disabled={chatCreated}
              onChange={(e) => {
                setData((d) => ({
                  ...d,
                  lastName: e.target.value || "",
                }));
              }}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={1}>
            <Typography align="right">Phone Number:</Typography>
          </Grid>
          <Grid item xs={2}>
            <TextField
              id="phone"
              label="Phone Number"
              variant="outlined"
              value={data?.phone}
              disabled={chatCreated}
              onChange={(e) => {
                setData((d) => ({
                  ...d,
                  phone: e.target.value || "",
                }));
              }}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={1}>
            <Typography align="right">Email:</Typography>
          </Grid>
          <Grid item xs={2}>
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              value={data?.email}
              disabled={chatCreated}
              onChange={(e) => {
                setData((d) => ({
                  ...d,
                  email: e.target.value || "",
                }));
              }}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={1}>
            <Typography align="right">Zip Code:</Typography>
          </Grid>
          <Grid item xs={2}>
            <TextField
              id="zip-code"
              label="Zip Code"
              variant="outlined"
              value={data?.zip}
              disabled={chatCreated}
              onChange={(e) => {
                setData((d) => ({
                  ...d,
                  zip: e.target.value || "",
                }));
              }}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={1}>
            <Typography align="right">Type:</Typography>
          </Grid>
          <Grid item xs={2}>
            <Select
              value={data.type}
              label="Type"
              disabled={chatCreated}
              onChange={(e) => {
                setData((d) => ({
                  ...d,
                  type: e.target.value || "",
                }));
              }}
            >
              <MenuItem value="WaitForInput">Wait For Input</MenuItem>
              <MenuItem value="ConnectAgent">Connect Agent</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid item>
          {data.type === "WaitForInput" ? (
            <Typography>
              A chat message will have to be sent from this page before a PA
              will be connected with the chat in MAX.
            </Typography>
          ) : (
            <Typography>
              A PA will be connected with the chat in MAX immediately.
            </Typography>
          )}
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={3} textAlign="center">
            <Button
              variant="outlined"
              onClick={onClickChat}
              disabled={chatCreated}
            >
              Create Chat Button!
            </Button>
          </Grid>
        </Grid>
        <Grid item>
          {chatCreated && (
            <Typography>
              Please click the "Live Chat" button in the lower right to begin.
              If you need to initiate another session, refresh the page.
            </Typography>
          )}
        </Grid>
      </Grid>
      <div id="embeddedChatTarget"></div>
    </>
  );
};

export default App;
